import React, { useEffect, useState } from "react";
import './Estadisticas.scss'
import CardEstadistica from "../../../components/molecules/CardEstadistica/CardEstadistica";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import InputText from "../../../components/atoms/InputText/InputText";
import { addCardex, getCards, getHistoricoUnidad, getsetEquipamiento, getTecnicos, getUnidades } from "./integracion";
import pencil from '../../../assets/icons/pencil.svg'
import add from '../../../assets/icons/add.svg'
import details from '../../../assets/icons/Details.svg'
import { Dialog } from "primereact/dialog";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import TextArea from "../../../components/atoms/TextArea/TextArea";
import Boton from "../../../components/atoms/Boton/Boton";
import { desEncriptar } from "../../../utilidades/encriptacion";
import { convertirFormatoFecha, extraerHora, formatearFecha } from "../../../utilidades/formateos";
import cita from '../../../assets/icons/dropdown_list.svg'
import { Tooltip } from "@mui/material";

const Estadisticas = () => {
    const [data, setData] = useState([]);
    const [visibleAdd, setVisibleAdd] = useState(false);
    const [AddData, setAddData] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");
    const [equipamientos, setEquipamientos] = useState([]);
    const [equipamiento, setEquipamiento] = useState(null);
    const [tecnicos, setTecnicos] = useState([]);
    const [tecnico, setTecnico] = useState(null);
    const [accion, setAccion] = useState(null);
    const [comentario, setComentario] = useState(null);
    const [visibleHistory, setVisibleHistory] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [cards, setCards] = useState([]);
    const [dataHistorico, setDataHistorico] = useState([]);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState()
    const optionsActions = [
        { name: "Instalación nueva", code: 1 },
        { name: "Revision", code: 2 },
        { name: "Reinstalacion", code: 3 }
    ]


    useEffect(() => {
        getUnidades(setData)
        getsetEquipamiento(setEquipamientos)
        getTecnicos(setTecnicos)
        getCards(setCards)
    }, [])

    useEffect(() => {
        if (visibleHistory) {

            getHistoricoUnidad(unidadSeleccionada, setDataHistorico)
        }

    }, [visibleHistory])


    // Función para actualizar el filtro global
    const onGlobalFilterChange = (e) => {
        setGlobalFilter(e.target.value);
    };
    const imagenUnidad = (rowData) => {
        return (
            <>
                <img width={120} style={{ borderRadius: "10px" }} src={'https://sumaenlinea.mx/Imagenes/' + rowData.FOTOGRAFIA} alt="" />
            </>
        )
    }
    const fechaTemplate = (rowData) => {
        return (
            <>
                <div>{convertirFormatoFecha(formatearFecha(rowData.FECHA))} {extraerHora(rowData.FECHA)}</div>
            </>
        )
    }
    const citaTemplate = (rowData) => {
        return (
            <>
                <div>{rowData.ID_CITA != 0 ? rowData.ID_CITA : "Sin cita"}</div>
            </>
        )
    }
    const activoTemplate = (rowData) => {
        return (
            <>
                {rowData.ACTIVA == true ? '✅' : rowData.ACTIVA == false ? '❌' : 'sin dato'}
            </>
        )
    }
    const accionTemplate = (rowData) => {
        return (
            <>
                <div>
                    {
                        rowData.ACCION == 'Instalación nueva' ?
                            <>
                                <div className="nueva">{rowData.ACCION}</div>
                            </> :
                            rowData.ACCION == 'Reinstalacion' ?
                                <>
                                    <div className="reinstalacion">{rowData.ACCION}</div>

                                </> :
                                <>
                                     <div className="revicion">{rowData.ACCION}</div>
                                </>

                    }

                </div>
            </>
        )
    }

    const acciones = (rowData) => {
        return (
            <div className="containerActions">
                <Tooltip title="Agregar nuevo registro al historial de la unidad">
                    <div className="boton add" onClick={() => { setVisibleAdd(true); setAddData(rowData) }}><img src={add} width={12} alt="" /></div>
                </Tooltip>
                <Tooltip title="Mostrar historial">
                    <div className="boton show" onClick={() => { setVisibleHistory(true); setUnidadSeleccionada(rowData.ID) }}><img src={details} width={12} alt="" /></div>
                </Tooltip>
                {/* <Tooltip title="Agendar nueva cita">
                    <div className="boton edit" onClick={() => { setVisibleEdit(true); setUnidadSeleccionada(rowData.ID) }}><img src={cita} width={12} alt="" /></div>
                </Tooltip> */}
            </div>
        )

    }
    const registarCardex = () => {
        const key = process.env.REACT_APP_CLAVE_INCRIPTACION
        const dataUsuario = sessionStorage.getItem('dataClient')

        const desencriptar = JSON.parse(desEncriptar(dataUsuario, key))
        if (equipamiento && accion && tecnico) {
            const data = {
                id_equipamiento: equipamiento.code,
                accion: accion.code,
                tecnico: tecnico.code,
                observacion: comentario,
                id_unidad: AddData.ID,
                id_usuario: desencriptar.user.ID,

            }
            setVisibleAdd(false)
            addCardex(data)
        }

    }




    return (
        <div className="Estadisticas">
            <div className="dardsContainer">
                <CardEstadistica titulo={"Trampa De Combustible"} total={cards?.TOTAL_UNIDADES} completadas={cards?.TRAMPAS_COMBUSTIBLE?.length} ></CardEstadistica>
                <CardEstadistica titulo={"Sensor De Combustible"} total={cards?.TOTAL_UNIDADES} completadas={cards?.SENSOR_COMBUSTIBLE?.length} ></CardEstadistica>
                <CardEstadistica titulo={"Letreros"} total={cards?.TOTAL_UNIDADES} completadas={cards?.LETREROS?.length} ></CardEstadistica>
                {/* <CardEstadistica total={cards?.TOTAL_UNIDADES} completadas={100} ></CardEstadistica> */}
            </div>
            <InputText
                title="Buqueda"
                value={globalFilter}
                onChange={onGlobalFilterChange}
                placeholder="Buscar en toda la tabla"
                style={{ marginBottom: '20px', width: '300px' }}
            />
            <DataTable value={data} showGridlines scrollable scrollHeight="calc(100vh - 400px)" globalFilter={globalFilter} responsiveLayout="scroll" virtualScrollerOptions={{ itemSize: 40 }}>
                <Column field="ID" header="ID" sortable />
                <Column field="DESCRIPCION" header="Descripción" sortable />
                <Column field="TIPO" header="Tipo" sortable />
                <Column field="MODELO" header="Modelo" sortable />
                <Column field="FOTOGRAFIA" header="Fotografía" body={imagenUnidad} sortable />
                <Column field="ACTIVO" header="Activo" body={activoTemplate} sortable />
                <Column field="GPS" header="GPS" sortable />
                <Column field="ITEM_ID_WIALON" header="ID Wialon" sortable />
                <Column header="ACCIONES" body={acciones} sortable />

            </DataTable>
            <Dialog header="Agregar Seguimiento" visible={visibleAdd} className="add-modal-estadistics" onHide={() => { if (!visibleAdd) return; setVisibleAdd(false); }}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <div className="d-flex">
                    <div className="unidad">{AddData?.DESCRIPCION}</div>
                    <div>|</div>
                    <div className="unidad orange"> U - {AddData?.ID}</div>
                </div>
                <div className="container-inputs">
                    <div className="input-group">
                        <InputLista onChange={(e) => { setEquipamiento(e.value) }} value={equipamiento} options={equipamientos} titulo={"Tipo de equipamiento"}></InputLista>
                        <InputLista onChange={(e) => { setAccion(e.value) }} value={accion} options={optionsActions} titulo={"Acción"}></InputLista>
                    </div>
                    <div className="input-group" style={{ marginTop: "10px" }}>
                        <InputLista onChange={(e) => { setTecnico(e.value) }} value={tecnico} options={tecnicos} titulo={"Técnico"}></InputLista>
                        <TextArea obligatorio={false} onChange={(e) => { setComentario(e.target.value) }} value={comentario} titulo="Observaciónes"></TextArea>
                    </div>
                    <div className="buttonGroup">
                        <Boton onClick={() => registarCardex()}>Guardar</Boton>
                        <Boton className={'cancelar'} onClick={() => { setVisibleAdd(false) }}>Cancelar</Boton>
                    </div>
                </div>
            </Dialog>
            <Dialog header="Ver historial" visible={visibleHistory} className="add-modal-estadistics" onHide={() => { if (!visibleHistory) return; setVisibleHistory(false); }}
                style={{ width: '70vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <div className="unidad orange"> Unidad - {unidadSeleccionada}</div>
                <DataTable value={dataHistorico} showGridlines scrollable scrollHeight="calc(100vh - 550px)" globalFilter={globalFilter} responsiveLayout="scroll" virtualScrollerOptions={{ itemSize: 40 }}>
                    <Column field="TIPO_EQUIPAMIENTO" header="TIPO_EQUIPAMIENTO" sortable />
                    <Column field="ACCION" header="ACCION" body={accionTemplate} sortable />
                    <Column field="OBSERVACIONES" header="OBSERVACIONES" sortable />
                    <Column field="TECNICO" header="TECNICO" sortable />
                    <Column field="FECHA" header="FECHA" body={fechaTemplate} sortable />
                    <Column field="USUARIO_QUIEN_REGISTRO" header="USUARIO_QUIEN_REGISTRO" sortable />
                    <Column field="ID_CITA" header="ID_CITA" body={citaTemplate} sortable />

                </DataTable>

            </Dialog>
            {/* <Dialog header="Editar Unidad" visible={visibleEdit} className="add-modal-estadistics" onHide={() => { if (!visibleEdit) return; setVisibleEdit(false); }}
                style={{ width: '70vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <div className="unidad orange"> Unidad - {unidadSeleccionada}</div>
                <div className="containerInputs">
                    <InputText title="Gps"></InputText>
                    <InputText title="id_wialon"></InputText>
                </div>
                <div className="buttonGroup">
                    <Boton onClick={() => registarCardex()}>Guardar</Boton>
                    <Boton className={'cancelar'} onClick={() => { setVisibleAdd(false) }}>Cancelar</Boton>
                </div>

            </Dialog> */}

        </div>
    )
}
export default Estadisticas